import React, { lazy } from "react";
import { Navigate } from "react-router-dom";
import ProtectedRoute from "./utils/protected-route";
import { getFirstPermittedRoute } from "./containers/Header/SideNavData";
const FDMemoMake = lazy(
  () => import("./pages/FixedDeposit/MemoContents/Memo/FDMemoMake"),
);
const UpdateMemoFDMake = lazy(
  () =>
    import("./pages/FixedDeposit/MemoContents/UpdateMemoNew/UpdateMemoFDMake"),
);
const PermissionsManagement = lazy(
  () => import("./pages/Setting/PermissionsManagement/PermissionsManagement"),
);
const SyncADandBS = lazy(() => import("./components/datepickers/syncADandBS"));

const MutualFundUpdateMemo = lazy(
  () => import("./pages/MutualFund/mutualFundMemo/UpdateMemo/UpdateMemo"),
);
const DebentureUpdateMemo = lazy(
  () => import("./pages/Debenture/debentureMemo/UpdateMemo/UpdateMemo"),
);
const PreferenceShareUpdateMemo = lazy(
  () =>
    import("./pages/PreferenceShare/preferenceShareMemo/UpdateMemo/UpdateMemo"),
);

const Dashboard = lazy(() => import("./pages/Dashboard/Dashboard"));
const Shares = lazy(() => import("./pages/Shares/Shares"));
const FDMemo = lazy(
  () => import("./pages/FixedDeposit/MemoContents/Memo/Memo"),
);
const Login = lazy(() => import("./pages/Login/Login"));
const FixedDeposit = lazy(() => import("./pages/FixedDeposit/FixedDeposit"));
const UpdateMemo = lazy(
  () => import("./pages/FixedDeposit/MemoContents/UpdateMemoNew/UpdateMemo"),
);
const UpdateMemoRenew = lazy(
  () =>
    import("./pages/FixedDeposit/MemoContents/UpdateMemoRenew/UpdateMemoRenew"),
);
const ShareMemo = lazy(() => import("./pages/Shares/shareMemo/Memo/Memo"));
const DebentureMemo = lazy(
  () => import("./pages/Debenture/debentureMemo/Memo/Memo"),
);
const Debenture = lazy(() => import("./pages/Debenture/Debenture"));
const PreferenceShare = lazy(
  () => import("./pages/PreferenceShare/PreferenceShare"),
);
const PreferenceShareMemo = lazy(
  () => import("./pages/PreferenceShare/preferenceShareMemo/Memo/Memo"),
);
const MutualFund = lazy(() => import("./pages/MutualFund/MutualFund"));
const MutualFundMemo = lazy(
  () => import("./pages/MutualFund/mutualFundMemo/Memo/Memo"),
);
const PageNotFound = lazy(() => import("./pages/PageNotFound/PageNotFound"));
const ReportsPage = lazy(() => import("./pages/Reports/Reports"));
const ShareReportsPage = lazy(() => import("./pages/Reports/share-report"));
const DebentureReportsPage = lazy(
  () => import("./pages/Reports/debenture-report"),
);
const GovernmentBondReportsPage = lazy(
  () => import("./pages/Reports/government-bond-report"),
);
const MutualFundReportsPage = lazy(
  () => import("./pages/Reports/mutual-fund-report"),
);
const PreferenceShareReportsPage = lazy(
  () => import("./pages/Reports/preference-share-report"),
);
const EntryBookPage = lazy(() => import("./pages/Reports/entry-book"));
const AlternativeReport = lazy(
  () => import("./pages/Reports/AlternativeReport/AlternativeReport"),
);
const BankCategory = lazy(
  () => import("./pages/Setting/BankCategory/BankCategory"),
);
const Banks = lazy(() => import("./pages/Setting/Banks/Banks"));
const BankBranch = lazy(() => import("./pages/Setting/BankBranch/BankBranch"));
const Users = lazy(() => import("./pages/Setting/User/User"));
const Interestaccrued = lazy(
  () => import("./pages/interestAccrued/InterestAccrued"),
);
const Investmentdirectives = lazy(
  () => import("./pages/investmentdirectery/Investmentdirectives"),
);
const InvestmentDirectiveSetting = lazy(
  () => import("./pages/Setting/InvestmentDirective/InvestmentDirective"),
);
const ShareScript = lazy(
  () => import("./pages/Setting/ShareScript/ShareScript"),
);
const MutualFundScript = lazy(
  () => import("./pages/Setting/MutualFundScript/MutualFundScript"),
);
const DebentureScript = lazy(
  () => import("./pages/Setting/DebentureScript/DebentureScript"),
);
const GovernmentBondScript = lazy(
  () => import("./pages/Setting/GovernmentBondScript/GovernmentBondScript"),
);
const InvestmentDirectiveValue = lazy(
  () =>
    import("./pages/Setting/InvestmentDirectiveValue/InvestmentDirectiveValue"),
);

const RolesManagement = lazy(
  () => import("./pages/Setting/RolesManagement/RolesManagement"),
);
const BankQuarterlyReports = lazy(
  () => import("./pages/Setting/BankQuarterlyReports/BankQuarterlyReports"),
);
const AlternativeInvestmentCompany = lazy(
  () =>
    import("./pages/Setting/AlternativeInvestmentCompany/AlternativeInvestmentCompany"),
);
const AlternativeInvestment = lazy(
  () => import("./pages/AlternativeInvestment/AlternativeInvestment"),
);
const PevcDashboard = lazy(
  () => import("./pages/PEVC/Dashboard/PevcDashboard"),
);
const FundSummary = lazy(() => import("./pages/PEVC/FundSummary/FundSummary"));
const InvestmentDetails = lazy(
  () => import("./pages/PEVC/InvestmentDetails/InvestmentDetails"),
);
const PortfolioFinancials = lazy(
  () => import("./pages/PEVC/PortfolioFinancials/PortfolioFinancials"),
);
const FundFinancials = lazy(
  () => import("./pages/PEVC/FundFinancials/FundFinancials"),
);
const CapitalCompanyDashboard = lazy(
  () => import("./pages/CapitalCompany/CapitalCompanyDashboard"),
);
const InvestmentCompanyDashboard = lazy(
  () => import("./pages/InvestmentCompany/InvestmentCompanyDashboard"),
);
const HydropowerDashboard = lazy(
  () => import("./pages/InvestmentCompany/Hydropower/HydropowerDashboard"),
);
const HospitalityDashboard = lazy(
  () => import("./pages/InvestmentCompany/Hospitality/HospitalityDashboard"),
);
const InvestmentPortfolioDashboard = lazy(
  () => import("./pages/InvestmentPortfolio/InvestmentPortfolioDashboard"),
);
const BrokerList = lazy(() => import("./pages/Setting/BrokerList/BrokerList"));
const ManualShare = lazy(
  () => import("./pages/Setting/ManualShare/ManualShare"),
);
const ManualDebenture = lazy(
  () => import("./pages/Setting/ManualDebenture/ManualDebenture"),
);
const ManualMutualFund = lazy(
  () => import("./pages/Setting/ManualMutualFund/ManualMutualFund"),
);
const ManualPreferenceShare = lazy(
  () => import("./pages/Setting/ManualPreferenceShare/ManualPreferenceShare"),
);
const ManualGovernmentBond = lazy(
  () => import("./pages/Setting/ManualGovernmentBond/ManualGovernmentBond"),
);

const GovernmentBond = lazy(() => import("./pages/GovernmentBond/Debenture"));
const GovernmentBondMemo = lazy(
  () => import("./pages/GovernmentBond/GovernmentBondMemo/Memo/Memo"),
);
const GovernmentBondUpdateMemo = lazy(
  () =>
    import("./pages/GovernmentBond/GovernmentBondMemo/UpdateMemo/UpdateMemo"),
);

export const routes = [
  {
    path: "/dashboard",
    element: (
      <ProtectedRoute requiredPermission="DASHBOARD">
        <Dashboard />
      </ProtectedRoute>
    ),
  },
  {
    path: "/share/shares",
    element: (
      <ProtectedRoute requiredPermission="SHARE">
        <Shares />
      </ProtectedRoute>
    ),
  },
  {
    path: "/",
    element: (
      <ProtectedRoute>
        <Navigate to={getFirstPermittedRoute()} replace />
      </ProtectedRoute>
    ),
  },
  {
    path: "/fd/memo",
    element: (
      <ProtectedRoute requiredPermission="FD_MEMO">
        <FDMemo />
      </ProtectedRoute>
    ),
  },
  {
    path: "/fd/memo/fixed-deposit/make/:id/:bankname/:branchname",
    element: (
      <ProtectedRoute requiredPermission="FD_MEMO">
        <FDMemoMake />
      </ProtectedRoute>
    ),
  },
  {
    path: "/fd/memo/fixed-deposit/make/list/:id",
    element: (
      <ProtectedRoute requiredPermission="FD_MEMO">
        <UpdateMemoFDMake />
      </ProtectedRoute>
    ),
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/fd/fixed-deposit",
    element: (
      <ProtectedRoute requiredPermission="FD">
        <FixedDeposit />
      </ProtectedRoute>
    ),
  },
  {
    path: "/fd/memo/edit/new/:id",
    element: (
      <ProtectedRoute requiredPermission="FD_MEMO">
        <UpdateMemo />
      </ProtectedRoute>
    ),
  },
  {
    path: "/fd/memo/edit/renew/:id",
    element: (
      <ProtectedRoute requiredPermission="FD_MEMO">
        <UpdateMemoRenew />
      </ProtectedRoute>
    ),
  },
  {
    path: "/fd/memo/edit/maturity/:id",
    element: (
      <ProtectedRoute requiredPermission="FD_MEMO">
        <UpdateMemoRenew isMeturity={true} />
      </ProtectedRoute>
    ),
  },
  {
    path: "/fd/memo/edit/pre-mature/:id",
    element: (
      <ProtectedRoute requiredPermission="FD_MEMO">
        <UpdateMemoRenew isPreMature={true} isMeturity={true} />
      </ProtectedRoute>
    ),
  },
  {
    path: "/share/memo",
    element: (
      <ProtectedRoute requiredPermission="SHARE_MEMO">
        <ShareMemo />
      </ProtectedRoute>
    ),
  },
  {
    path: "/debenture/debentures",
    element: (
      <ProtectedRoute requiredPermission="DEBENTURE">
        <Debenture />
      </ProtectedRoute>
    ),
  },
  {
    path: "/debenture/memo",
    element: (
      <ProtectedRoute requiredPermission="DEBENTURE_MEMO">
        <DebentureMemo />
      </ProtectedRoute>
    ),
  },
  {
    path: "/debenture/memo/edit/:id",
    element: (
      <ProtectedRoute requiredPermission="DEBENTURE_MEMO">
        <DebentureUpdateMemo />
      </ProtectedRoute>
    ),
  },
  {
    path: "/government-bond/bonds",
    element: (
      <ProtectedRoute requiredPermission="GOVERNMENT_BOND_VIEW">
        <GovernmentBond />
      </ProtectedRoute>
    ),
  },
  {
    path: "/government-bond/memo",
    element: (
      <ProtectedRoute requiredPermission="GOVERNMENT_BOND_VIEW_MEMO">
        <GovernmentBondMemo />
      </ProtectedRoute>
    ),
  },
  {
    path: "/government-bond/memo/edit/:id",
    element: (
      <ProtectedRoute requiredPermission="GOVERNMENT_BOND_VIEW_MEMO">
        <GovernmentBondUpdateMemo />
      </ProtectedRoute>
    ),
  },
  {
    path: "/fund/mutual-funds",
    element: (
      <ProtectedRoute requiredPermission="MUTUALFUND">
        <MutualFund />
      </ProtectedRoute>
    ),
  },
  {
    path: "/fund/memo/edit/:id",
    element: (
      <ProtectedRoute requiredPermission="MUTUALFUND_MEMO">
        <MutualFundUpdateMemo />
      </ProtectedRoute>
    ),
  },
  {
    path: "/fund/transaction",
    element: (
      <ProtectedRoute requiredPermission="MUTUALFUND_MEMO">
        <MutualFundMemo />
      </ProtectedRoute>
    ),
  },
  {
    path: "/fund/memo",
    element: (
      <ProtectedRoute requiredPermission="MUTUALFUND_MEMO">
        <MutualFundMemo />
      </ProtectedRoute>
    ),
  },
  {
    path: "/reports/all",
    element: (
      <ProtectedRoute requiredPermission="REPORTS_ALL">
        <ReportsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/reports/report-share",
    element: (
      <ProtectedRoute requiredPermission="REPORTS_SHARE">
        <ShareReportsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/reports/report-debenture",
    element: (
      <ProtectedRoute requiredPermission="REPORTS_DEBENTURE">
        <DebentureReportsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/reports/report-gov-bond",
    element: (
      <ProtectedRoute requiredPermission="REPORTS_GOVERNMENT_BOND">
        <GovernmentBondReportsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/reports/report-mutual-fund",
    element: (
      <ProtectedRoute requiredPermission="REPORTS_MUTUAL_FUND">
        <MutualFundReportsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/reports/report-pref-share",
    element: (
      <ProtectedRoute requiredPermission="REPORTS_PREFERENCE_SHARE">
        <PreferenceShareReportsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/reports/entry-book",
    element: (
      <ProtectedRoute requiredPermission="ENTRY_BOOK">
        <EntryBookPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/reports/alternative-investment-report",
    element: (
      <ProtectedRoute requiredPermission="REPORT_ALT_INV">
        <AlternativeReport />
      </ProtectedRoute>
    ),
  },
  {
    path: "/preference-share",
    element: (
      <ProtectedRoute requiredPermission="PREFERENCE_SHARE_VIEW">
        <PreferenceShare />
      </ProtectedRoute>
    ),
  },
  {
    path: "/pref-share/memo",
    element: (
      <ProtectedRoute requiredPermission="PREFERENCE_SHARE_MEMO">
        <PreferenceShareMemo />
      </ProtectedRoute>
    ),
  },
  {
    path: "/pref-share/memo/edit/:id",
    element: (
      <ProtectedRoute requiredPermission="PREFERENCE_SHARE_MEMO">
        <PreferenceShareUpdateMemo />
      </ProtectedRoute>
    ),
  },
  {
    path: "/interestaccrued",
    element: (
      <ProtectedRoute requiredPermission="INTEREST_ACCRUED">
        <Interestaccrued />
      </ProtectedRoute>
    ),
  },
  {
    path: "/directives",
    element: (
      <ProtectedRoute requiredPermission="INVESTMENT_DIRECTIVES">
        <Investmentdirectives />
      </ProtectedRoute>
    ),
  },
  {
    path: "/setting/bank-category",
    element: (
      <ProtectedRoute requiredPermission="BANK_CATEGORY_VIEW">
        <BankCategory />
      </ProtectedRoute>
    ),
  },
  {
    path: "/setting/banks",
    element: (
      <ProtectedRoute requiredPermission="BANK_VIEW">
        <Banks />
      </ProtectedRoute>
    ),
  },
  {
    path: "/setting/bank-branch",
    element: (
      <ProtectedRoute requiredPermission="BANK_BRANCH_VIEW">
        <BankBranch />
      </ProtectedRoute>
    ),
  },
  {
    path: "/setting/bank-quarterly-reports",
    element: (
      <ProtectedRoute requiredPermission="BANK_QUARTERLY_REPORT_VIEW">
        <BankQuarterlyReports />
      </ProtectedRoute>
    ),
  },
  {
    path: "/setting/users",
    element: (
      <ProtectedRoute requiredPermission="USER_MANAGEMENT_VIEW">
        <Users />
      </ProtectedRoute>
    ),
  },
  {
    path: "/setting/sharescript",
    element: (
      <ProtectedRoute requiredPermission="SHARE_SCRIPT_MANAGEMENT_VIEW">
        <ShareScript />
      </ProtectedRoute>
    ),
  },
  {
    path: "/setting/brokerlist",
    element: (
      <ProtectedRoute requiredPermission="BROKER_MANAGEMENT_VIEW">
        <BrokerList />
      </ProtectedRoute>
    ),
  },
  {
    path: "/setting/debenturescript",
    element: (
      <ProtectedRoute requiredPermission="DEBENTURE_SCRIPT_MANAGEMENT_VIEW">
        <DebentureScript />
      </ProtectedRoute>
    ),
  },
  {
    path: "/setting/governmentbondscript",
    element: (
      <ProtectedRoute requiredPermission="GOVERNMENT_BOND_SCRIPT_MANAGEMENT_VIEW">
        <GovernmentBondScript />
      </ProtectedRoute>
    ),
  },
  {
    path: "/setting/mutualfundscript",
    element: (
      <ProtectedRoute requiredPermission="MUTUAL_FUND_SCRIPT_MANAGEMENT_VIEW">
        <MutualFundScript />
      </ProtectedRoute>
    ),
  },
  {
    path: "/setting/investment-directive-titles",
    element: (
      <ProtectedRoute requiredPermission="INVESTMENT_DIRECTIVE_TITLES_VIEW">
        <InvestmentDirectiveSetting />
      </ProtectedRoute>
    ),
  },
  {
    path: "/setting/investment-directive-value",
    element: (
      <ProtectedRoute requiredPermission="INVESTMENT_DIRECTIVE_VALUES_VIEW">
        <InvestmentDirectiveValue />
      </ProtectedRoute>
    ),
  },
  {
    path: "/setting/roles-management",
    element: (
      <ProtectedRoute requiredPermission="USER_ROLES_MANAGEMENT_VIEW">
        <RolesManagement />
      </ProtectedRoute>
    ),
  },
  {
    path: "/setting/permission-management",
    element: (
      <ProtectedRoute requiredPermission="USER_PERMISSION_MANAGEMENT_VIEW">
        <PermissionsManagement />
      </ProtectedRoute>
    ),
  },
  {
    path: "/setting/alternative-investment-company",
    element: (
      <ProtectedRoute requiredPermission="ALT_INVESTMENT_COMPANY_VIEW">
        <AlternativeInvestmentCompany />
      </ProtectedRoute>
    ),
  },
  {
    path: "/setting/manual-share",
    element: (
      <ProtectedRoute requiredPermission="SHARE">
        <ManualShare />
      </ProtectedRoute>
    ),
  },
  {
    path: "/setting/manual-debenture",
    element: (
      <ProtectedRoute requiredPermission="DEBENTURE">
        <ManualDebenture />
      </ProtectedRoute>
    ),
  },
  {
    path: "/setting/manual-mutualfund",
    element: (
      <ProtectedRoute requiredPermission="MUTUALFUND">
        <ManualMutualFund />
      </ProtectedRoute>
    ),
  },
  {
    path: "/setting/manual-preferenceshare",
    element: (
      <ProtectedRoute requiredPermission="PREFERENCE_SHARE_VIEW">
        <ManualPreferenceShare />
      </ProtectedRoute>
    ),
  },
  {
    path: "/setting/manual-government-bond",
    element: (
      <ProtectedRoute requiredPermission="GOVERNMENT_BOND_VIEW">
        <ManualGovernmentBond />
      </ProtectedRoute>
    ),
  },
  {
    path: "/alternative-investment",

    element: (
      <ProtectedRoute requiredPermission="ALT_INVESTMENT_VIEW">
        <AlternativeInvestment />
      </ProtectedRoute>
    ),
  },
  {
    path: "/alt-inv/pevc-dashboard",
    element: (
      <ProtectedRoute requiredPermission="ALT_INVESTMENT_VIEW">
        <PevcDashboard />
      </ProtectedRoute>
    ),
  },
  {
    path: "/alt-inv/fund-summary",
    element: (
      <ProtectedRoute requiredPermission="ALT_INVESTMENT_VIEW">
        <FundSummary />
      </ProtectedRoute>
    ),
  },
  {
    path: "/alt-inv/investment-details",
    element: (
      <ProtectedRoute requiredPermission="ALT_INVESTMENT_VIEW">
        <InvestmentDetails />
      </ProtectedRoute>
    ),
  },
  {
    path: "/alt-inv/portfolio-financials",
    element: (
      <ProtectedRoute requiredPermission="ALT_INVESTMENT_VIEW">
        <PortfolioFinancials />
      </ProtectedRoute>
    ),
  },
  {
    path: "/alt-inv/fund-financials",
    element: (
      <ProtectedRoute requiredPermission="ALT_INVESTMENT_VIEW">
        <FundFinancials />
      </ProtectedRoute>
    ),
  },
  {
    path: "/alt-inv/investment-portfolio",
    element: (
      <ProtectedRoute requiredPermission="ALT_INVESTMENT_VIEW">
        <InvestmentPortfolioDashboard />
      </ProtectedRoute>
    ),
  },
  {
    path: "/alt-inv/capital-company",
    element: (
      <ProtectedRoute requiredPermission="ALT_INVESTMENT_VIEW">
        <CapitalCompanyDashboard />
      </ProtectedRoute>
    ),
  },
  {
    path: "/alt-inv/capital-dashboard",
    element: (
      <ProtectedRoute requiredPermission="ALT_INVESTMENT_VIEW">
        <CapitalCompanyDashboard />
      </ProtectedRoute>
    ),
  },
  {
    path: "/alt-inv/investment-company",
    element: (
      <ProtectedRoute requiredPermission="ALT_INVESTMENT_VIEW">
        <InvestmentCompanyDashboard />
      </ProtectedRoute>
    ),
  },
  {
    path: "/alt-inv/investment-company/hydropower",
    element: (
      <ProtectedRoute requiredPermission="ALT_INVESTMENT_VIEW">
        <HydropowerDashboard />
      </ProtectedRoute>
    ),
  },
  {
    path: "/alt-inv/investment-company/hospitality",
    element: (
      <ProtectedRoute requiredPermission="ALT_INVESTMENT_VIEW">
        <HospitalityDashboard />
      </ProtectedRoute>
    ),
  },
  {
    path: "/test-bs",
    element: (
      <ProtectedRoute>
        <SyncADandBS />
      </ProtectedRoute>
    ),
  },
  { path: "/*", element: <PageNotFound /> },
];
